import React from "react";
import { Alert } from "../api/alerts";
import { BusETA } from "../api/buseta";
import { TrainETA } from "../api/metroeta";

type AlertListProps = {
  alerts?: Alert[];
  busETAs?: BusETA[];
  trainETAs?: TrainETA[];
};

// Namespaced by mode so a bus route ID can never match a rail line code.
const codeKey = (mode: Alert["mode"], code: string): string =>
  `${mode}:${code.toUpperCase()}`;

const codesOnScreen = (
  busETAs: BusETA[] = [],
  trainETAs: TrainETA[] = [],
): Set<string> =>
  new Set([
    ...trainETAs.map((eta) => codeKey("rail", eta.line)),
    ...busETAs.map((eta) => codeKey("bus", eta.routeID)),
  ]);

export const AlertList: React.FC<AlertListProps> = ({
  alerts,
  busETAs,
  trainETAs,
}) => {
  if (!alerts || alerts.length === 0) return null;

  const onScreen = codesOnScreen(busETAs, trainETAs);
  const matching = alerts.filter((alert) =>
    alert.affected.some((code) => onScreen.has(codeKey(alert.mode, code))),
  );
  if (matching.length === 0) return null;

  return (
    <details className="alert-box">
      <summary className="alert-box-summary">
        Alerts: {matching.length}
        <span className="alert-box-arrow" aria-hidden="true" />
      </summary>
      <div className="alert-list">
        {matching.map((alert) => (
          <div className="alert-item" key={alert.id}>
            <span className="alert-codes">
              {alert.affected
                .filter((code) => onScreen.has(codeKey(alert.mode, code)))
                .join(", ")}
            </span>
            <p className="alert-text">{alert.description}</p>
          </div>
        ))}
      </div>
    </details>
  );
};
